import React from 'react';
import './i18n';
import './styles/globals.css';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import VersionSection from './components/VersionSection';
import ComparisonTable from './components/ComparisonTable';
import ProductsSection from './components/ProductsSection';
import SubscriptionSection from './components/SubscriptionSection';
import AboutSection from './components/AboutSection';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Navigation />
      <Hero />
      <VersionSection />
      <ComparisonTable />
      <ProductsSection />
      <SubscriptionSection />
      <AboutSection />
      <Footer />
    </div>
  );
}

export default App;
